import { Controller } from "@hotwired/stimulus"

const options = {
  enableHighAccuracy: true, // Fuerza el uso del hardware GPS del teléfono
  timeout: 5000,            // Tiempo máximo de espera (5 segundos)
  maximumAge: 0,            // No usar ubicaciones guardadas en caché
};

export default class extends Controller {
  connect() {
    console.log("Probando geolocalización nativa del paciente...");

    // 1. Verificar si el navegador de verdad soporta Geolocalización
    if (!navigator.geolocation) {
      console.warn("La geolocalización no es soportada por este navegador.");
      this.manejarErrorVisual("Tu navegador no soporta geolocalización.");
      return;
    }

    // 2. Llamar al GPS nativo del dispositivo
    navigator.geolocation.getCurrentPosition(
      this.success.bind(this),
      this.error.bind(this),
      options
    );
  }

  // Se ejecuta SÓLO si el usuario aceptó los permisos y el GPS obtuvo coordenadas
  success(pos) {
    const crd = pos.coords;
    console.log("¡Posición actual obtenida con éxito!");
    console.log(`Latitude paciente: ${crd.latitude}`);
    console.log(`Longitude paciente: ${crd.longitude}`);
    console.log(`Precisión: ${crd.accuracy} metros.`);

    // Capturar elementos del DOM de forma segura
    const latInput = document.getElementById('lat');
    const lngInput = document.getElementById('lng');
    const btnGenerar = document.getElementById('btn-generar');
    const warningMessage = this.element.querySelector('[data-geo-warning]');

    // Inyectar las coordenadas reales en los campos ocultos de Rails
    if (latInput && lngInput) {
      latInput.value = crd.latitude;
      lngInput.value = crd.longitude;
    }

    // ¡Habilitar el botón por fin!
    if (btnGenerar) {
      btnGenerar.disabled = false;
    }

    // Ocultar la advertencia roja de peligro
    if (warningMessage) {
      warningMessage.style.display = "none";
    }
  }

  // Se ejecuta si el GPS está apagado, si denegó el permiso, o si se cumplieron los 5 segundos (timeout)
  error(err) {
    console.warn(`ERROR GPS PACIENTE (${err.code}): ${err.message}`);
    
    let mensajeUsuario = "Activar Geolocalización para generar QR.";
    
    if (err.code === 1) { // PERMISSION_DENIED
      mensajeUsuario = "Has denegado el acceso al GPS. Por favor, actívalo en los permisos de tu navegador.";
    } else if (err.code === 3) { // TIMEOUT
      mensajeUsuario = "El GPS tardó demasiado en responder. Intenta recargar la página.";
    }

    this.manejarErrorVisual(mensajeUsuario);
  }

  manejarErrorVisual(mensaje) {
    const warningMessage = this.element.querySelector('[data-geo-warning]');
    const btnGenerar = document.getElementById('btn-generar');

    if (warningMessage) {
      warningMessage.style.display = "block";
      warningMessage.textContent = mensaje; // Le avisa al usuario REAL el motivo del bloqueo
    }

    if (btnGenerar) {
      btnGenerar.disabled = true; // Asegura que se mantenga bloqueado ante fallos
    }
  }
}